module.exports = __webpack_public_path__ + "img/dot-image.97113ed4.png";